import {
  UsePanelStateOptions,
  usePanelState,
} from '@/app/navigation/usePanelState';
import { useCallback, useEffect, useRef } from 'react';

export interface UsePanelFilterStateOptions extends UsePanelStateOptions {
  /**
   * Optional default filter to apply when no filter is set.
   * Only applied once on initial mount if panel state has no filter.
   */
  defaultFilter?: string;
}

/*
 * FIXME: filterState and default filter should integrate more closely with data-table so that:
 *  - there is less wiring-up to do
 *  - the searchbar knows when to show a reset button
 */
/**
 * Hook for managing filter state in panel-based tables.
 * Syncs filter value with panel state and provides a toggle for filter visibility.
 */
export function usePanelFilterState(options?: UsePanelFilterStateOptions) {
  const [state, setState] = usePanelState(options);

  const filterValue = state.filter ?? options?.defaultFilter ?? '';

  const setFilterValue = useCallback(
    (value: string | null) =>
      setState(({ filter, ...rest }) =>
        value !== null ? { ...rest, filter: value } : rest,
      ),
    [setState],
  );
  return {
    filterValue,
    setFilterValue,
  };
}
